/* AGS: the customer's design preview as the cart line thumbnail (v16 2026-10-15, v17 2026-10-16).
 *
 * v16: the slide cart on this site is the Zipify cart drawer app (class prefix "ocu-"), not the theme's
 * ajax cart, so the theme's _ags-preview thumbnail (v4) never reached it: Zipify draws the variant's
 * photo. Each Zipify line wrapper carries the line's properties as JSON in data-properties; when a line
 * has an _ags-preview URL from the AGS preview service, its <img> is pointed at that picture. Zipify is
 * a Vue app that redraws the drawer, so a MutationObserver re-applies it after every redraw.
 *
 * v17 (Danny 2026-10-16): the preview picture is served by the AGS app. If the app is down, a line must
 * never show a broken image:
 *   - Zipify drawer: the preview is loaded off-screen first and swapped in only once it has loaded;
 *     until then (or if it fails) the line keeps the product photo.
 *   - Cart page and the theme's ajax drawer (they write the preview URL straight into <img src>):
 *     a preview <img> that fails to load is pointed back at the line's product photo, read from
 *     /cart.js (the line whose _ags-preview is that URL).
 *   A failed preview is retried after a minute, so the picture comes back once the app is up.
 * Only URLs on https://app.athletesgiftshop.com/preview/ are touched. Checkout is not affected (Shopify
 * shows the variant photo there; only Shopify Plus can change it).
 * Loaded on every page from layout/theme.liquid.
 */
(function () {
  var OK = /^https:\/\/app\.athletesgiftshop\.com\/preview\//;
  var RETRY_MS = 60000, PROBE_MS = 15000;
  var state = {};          // preview url -> {s: 'loading'|'ok'|'bad', t: time}
  var queued = false;
  var cartReq = null;

  function now() { return new Date().getTime(); }
  function known(url) {
    var e = state[url];
    if (e && e.s === 'bad' && now() - e.t > RETRY_MS) { delete state[url]; return null; }
    return e || null;
  }
  // Load the preview off-screen; report ok / bad once.
  function probe(url) {
    if (known(url)) return;
    state[url] = { s: 'loading', t: now() };
    var im = new Image(), done = false;
    function fin(s) { if (done) return; done = true; state[url] = { s: s, t: now() }; soon(); }
    var timer = setTimeout(function () { fin('bad'); }, PROBE_MS);
    im.onload = function () { clearTimeout(timer); fin(im.naturalWidth > 0 ? 'ok' : 'bad'); };
    im.onerror = function () { clearTimeout(timer); fin('bad'); };
    im.src = url;
  }
  function sized(src) {
    if (!src) return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) {
      return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=400';
    }
    return src;
  }
  function cart() {
    if (!cartReq) {
      cartReq = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; });
      setTimeout(function () { cartReq = null; }, 5000);
    }
    return cartReq;
  }
  // A preview <img> on screen that did not load: show the product photo instead.
  function fallBack(img) {
    var url = img.getAttribute('src') || '';
    if (!OK.test(url) || img.getAttribute('data-ags-fallback-done') === url) return;
    img.setAttribute('data-ags-fallback-done', url);
    state[url] = { s: 'bad', t: now() };
    img.removeAttribute('srcset');
    var orig = img.getAttribute('data-ags-orig');
    if (orig) { img.setAttribute('src', orig); return; }
    cart().then(function (c) {
      var items = (c && c.items) || [];
      for (var i = 0; i < items.length; i++) {
        var p = items[i].properties || {};
        if (p['_ags-preview'] === url && items[i].image) {
          if (img.getAttribute('src') === url) img.setAttribute('src', sized(items[i].image));
          return;
        }
      }
    });
  }

  function apply() {
    queued = false;
    // Zipify drawer: swap in the preview only once it has loaded.
    var lines = document.querySelectorAll('.ocu-cart-line-item-wrapper[data-properties]');
    for (var i = 0; i < lines.length; i++) {
      var props;
      try { props = JSON.parse(lines[i].getAttribute('data-properties') || '{}'); } catch (e) { continue; }
      var url = props && props['_ags-preview'];
      if (!url || !OK.test(url)) continue;
      var img = lines[i].querySelector('.ocu-cart-line-item-image img');
      if (!img) continue;
      var cur = img.getAttribute('src') || '';
      var e = known(url);
      if (!e) { probe(url); continue; }
      if (e.s === 'ok' && cur !== url) {
        if (!OK.test(cur)) img.setAttribute('data-ags-orig', cur);
        img.setAttribute('src', url);
        img.removeAttribute('srcset');
      } else if (e.s === 'bad' && cur === url) {
        fallBack(img);
      }
    }
    // Any preview <img> already broken before this script ran (cart page, theme drawer).
    var imgs = document.querySelectorAll('img[src^="https://app.athletesgiftshop.com/preview/"]');
    for (var j = 0; j < imgs.length; j++) {
      if (imgs[j].complete && imgs[j].naturalWidth === 0) fallBack(imgs[j]);
    }
  }
  function soon() { if (!queued) { queued = true; (window.requestAnimationFrame || setTimeout)(apply); } }

  // A preview <img> that fails later (error events don't bubble, so listen in the capture phase).
  document.addEventListener('error', function (ev) {
    var t = ev.target;
    if (t && t.tagName === 'IMG' && OK.test(t.getAttribute('src') || '')) fallBack(t);
  }, true);

  function start() {
    apply();
    if (!window.MutationObserver) return;
    new MutationObserver(soon).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'data-properties']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
